import React, { Component } from 'react';
import { convertToMoney } from '../utils/formats'
import { MOVEMENTS_CURRENCY } from '../utils/enums'
import { getSelectedBranchId } from '../utils/branch';

var config = process.env;

class PriceAccountComponent extends Component {

	constructor(){
        super();
        this.state = {
            data: [],
            loaded: false,
		}
	}

    getCardStyle = () => ({
        borderRadius: '0.625rem',
        padding: '15px',
        minHeight: '114px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
    })

    getShimmerStyle = (extraStyle = {}) => ({
        backgroundColor: '#eef3f8',
        backgroundImage: 'linear-gradient(90deg, #eef3f8 0%, #f9fbfe 45%, #edf2f8 100%)',
        backgroundSize: '200% 100%',
        animation: 'summaryShimmer 1.35s linear infinite',
        boxShadow: 'inset 0 0 0 1px rgba(201, 211, 224, 0.12)',
        ...extraStyle,
    })

	componentWillMount() {
        this.fetchData();
    }

    fetchData = () => {
        const selectedBranchId = getSelectedBranchId();
        const branchQuery = selectedBranchId ? `?branchId=${selectedBranchId}` : '';
        var request = {
            method: 'GET',
            headers: { 
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        };
        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}accounts/summary${branchQuery}`, request)
        .then(results => { return results.json(); })
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                this.setState({ data: data.data, loaded: true });
            }
        });
    }

    renderLoadingCard = (index) => {
        return (
            <div className="col-md-3" key={`summary-loading-${index}`}>
                <div className="card card-small mb-4 pt-3" style={this.getCardStyle()}>
                    <div className="text-center" style={{ width: '100%' }}>
                        <div
                            className="mb-3 mx-auto summary-shimmer"
                            style={this.getShimmerStyle({
                                width: '72%',
                                minWidth: '180px',
                                height: '32px',
                                borderRadius: '10px',
                            })}
                        ></div>
                        <div
                            className="mx-auto summary-shimmer"
                            style={this.getShimmerStyle({
                                width: '38%',
                                minWidth: '96px',
                                height: '18px',
                                borderRadius: '999px',
                            })}
                        ></div>
                    </div>
                </div>
            </div>
        );
    }

    renderCard = () => {
        if (!this.state.loaded) {
            return (
                <div className="row">
                    {[0, 1, 2, 3].map((index) => this.renderLoadingCard(index))}
                </div>
            );
        }

        var items = [];
        this.state.data.forEach(item => {
            items.push(
                <div className="col-md-3" key={`summary-${item.id}`}>
                    <div className="card card-small mb-4 pt-3" style={this.getCardStyle()}>
                        <div className="text-center">
                            <div className="mb-3 mx-auto" style={{ fontSize: '24px'}}>{ MOVEMENTS_CURRENCY[item.currency] } { convertToMoney(item.amount) }</div>
                            <span className="text-muted d-block mb-2">{ item.name }</span>
                        </div>
                    </div>
                </div>
            );
        });
        return(<div className="row">{ items }</div>);
    }

	render() {
        return (  
            <>
                <style>{`
                    .summary-shimmer {
                        filter: saturate(0.92);
                    }

                    @keyframes summaryShimmer {
                        0% {
                            background-position: 200% 0;
                        }
                        100% {
                            background-position: -200% 0;
                        }
                    }
                `}</style>
                {this.renderCard()}
            </>
        );
    }
}

export default PriceAccountComponent;
